import { useMemo } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HugeiconsIcon } from '@hugeicons/react';
import cn from 'classnames';
import FeatherIcon from 'feather-icons-react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import styles from './IconComponent.module.scss';

export const IconComponent = ({
  icon,
  className,
  tip,
  placement = 'top',
  prefix = 'fi',
  size = 'original',
  // Available types:
  // - 'default': Standard checkmate Gradient style
  // - 'neutral-light': Light grey color
  // - 'neutral-dark': Dark grey color
  // - 'success': Green success indicator
  // - 'error': Red error/danger indicator
  // - 'warning': Yellow warning indicator
  // - 'info': Blue information indicator
  // - 'primary': Primary color
  // - 'secondary': Secondary color
  type = 'default',
  rounded = true,
  border = true,
  noBackground = false,
  oldIconLibrary = false,
  strokeWidth = 2,
  superfix,
  disabled = false,
  onClick = () => {},
}) => {
  const getSize = useMemo(() => {
    switch (size) {
      case 'xxSmall':
        return 12;
      case 'xSmall':
        return 16;
      case 'small':
      case 'medium':
        return 20;
      case 'large':
        return 28;
      case 'xlarge':
        return 30;
      case 'xxlarge':
        return 32;
      default:
        return 20;
    }
  }, [size]);

  return (
    <OverlayTrigger
      trigger={tip === undefined ? 'none' : ['hover', 'focus']}
      placement={placement}
      overlay={<Tooltip>{tip}</Tooltip>}>
      <div
        onClick={disabled ? () => {} : onClick}
        className={cn(styles.root, styles[type], 'u-relative', {
          [className]: className,
          [styles[size]]: size,
          [styles['no-rounded']]: !rounded,
          [styles['with-border']]: border,
          [styles['no-background']]: noBackground,
          [styles['disabled']]: disabled,
        })}>
        {superfix && <span className={cn(styles.superfix, 'u-absolute')}>{superfix}</span>}
        {!oldIconLibrary ? (
          <HugeiconsIcon
            size={getSize}
            icon={icon}
            className={styles.icon}
            strokeWidth={strokeWidth}
          />
        ) : prefix === 'fa' ? (
          <FontAwesomeIcon icon={icon} />
        ) : (
          <FeatherIcon size={getSize} icon={icon} className={styles.icon} />
        )}
      </div>
    </OverlayTrigger>
  );
};
